
/* Colora i dots nelle specs */
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var cm = {"bianco lucido":"#ffffff","nero lucido":"#1a1a1a","ocra lucido":"#c8a951","phard lucido":"#d4a89a","bianco matt":"#f0efe8","basalto matt":"#4a4a4a","brina matt":"#c8cfd4","londra matt":"#7a8a8a","foglia matt":"#6b8e5a","nero matt":"#2d2d2d","nocciola matt":"#8b6f47","cerniere cromo":"#c0c0c0","cerniere oro":"#d4af37","cerniere bronzo":"#8b6914"};
    document.querySelectorAll('#fxSpecColors .fx-spec-color-dot').forEach(function(dot) {
      var parent = dot.closest('[data-color-name]');
      if (!parent) return;
      var name = parent.dataset.colorName || '';
      var color = cm[name] || '#ccc';
      dot.style.background = color;
      if (color === '#ffffff' || color === '#f0efe8') dot.style.boxShadow = '0 0 0 1px #ccc';
    });
  }, 500);
});

